var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowsAltS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.22703 17.4803C3.93414 17.1874 3.93414 16.7125 4.22703 16.4197L7.13606 13.5106H0.767395C0.353181 13.5106 0.017395 13.1748 0.017395 12.7606C0.017395 12.3464 0.353182 12.0106 0.767395 12.0106L7.24262 12.0106L4.22703 8.99503C3.93414 8.70214 3.93414 8.22727 4.22703 7.93437C4.51992 7.64148 4.9948 7.64148 5.28769 7.93437L9.53033 12.177C9.82322 12.4699 9.82322 12.9448 9.53033 13.2377L5.28769 17.4803C4.9948 17.7732 4.51992 17.7732 4.22703 17.4803ZM19.7904 8.03467C20.0833 8.32756 20.0833 8.80244 19.7904 9.09533L16.8813 12.0044L23.25 12.0044C23.6642 12.0044 24 12.3401 24 12.7544C24 13.1686 23.6642 13.5044 23.25 13.5044L16.7748 13.5044L19.7904 16.52C20.0833 16.8128 20.0833 17.2877 19.7904 17.5806C19.4975 17.8735 19.0226 17.8735 18.7297 17.5806L14.4871 13.338C14.1942 13.0451 14.1942 12.5702 14.4871 12.2773L18.7297 8.03467C19.0226 7.74178 19.4975 7.74178 19.7904 8.03467Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsAltS);
export default __webpack_public_path__ + "static/media/arrows-alt-s.8cc21db7cdbce3491ffb4fe8c0c53e9f.svg";
export { ForwardRef as ReactComponent };